// removed by extract-text-webpack-plugin
module.exports = {"divider":"pois__divider___1IoNO","breadcrumbs":"pois__breadcrumbs___20OGQ"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/styles/pois.css
// module id = YLLQ
// module chunks = 2